import TypeofEvent from "../../assest/type of event.svg";
import Event from "../../assest/event.svg";
import Registration from "../../assest/registretion.svg";
import DataAnalytics from "../../assest/data analytic.svg";
import Security from "../../assest/security.svg";
import AdminTool from "../../assest/administrative.svg";
import graphic1 from "../../assest/about/oval1.svg";
import graphic2 from "../../assest/about/ovals.svg";
import { motion } from "framer-motion";

// Variants
const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.5 } },
};

const imageVariants = {
  hidden: { opacity: 0, rotate: -15 },
  visible: (delay) => ({
    opacity: 1,
    rotate: 0,
    transition: { duration: 1.2, delay },
  }),
};

const headingVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, delay: 0.6 } },
};

const featureContainerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.3 } },
};

const featureItemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.3 } },
};

const iconVariants = {
  hidden: { scale: 0 },
  visible: { scale: 1, transition: { duration: 1, delay: 0.2 } },
};

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.5 } },
};

const EventFeatures = () => {
  const Features = [
    {
      img: TypeofEvent,
      title: "Dynamic Scheduling",
    },
    {
      img: Event,
      title: "Multi-day Agenda",
    },
    {
      img: Registration,
      title: "Customizable Registrations",
    },
    {
      img: AdminTool,
      title: "Admin Dashboard",
    },
    {
      img: DataAnalytics,
      title: "Data analytics",
    },
    {
      img: Security,
      title: "Data Security",
    },
  ];

  return (
    <motion.div
      className="event-feature"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      viewport={{ once: true }}
    >
      <motion.img
        src={graphic1}
        className="left-illu"
        alt="icon"
        variants={imageVariants}
        custom={0.3}
        initial="hidden"
        animate="visible"
        viewport={{ once: true }}
      />
      <motion.img
        src={graphic2}
        className="right-illu"
        alt="icon"
        variants={imageVariants}
        custom={0.5}
        initial="hidden"
        animate="visible"
        viewport={{ once: true }}
      />
      <motion.h2
        className="sectionHeading"
        variants={headingVariants}
        initial="hidden"
        animate="visible"
        viewport={{ once: true }}
      >
        KEY FEATURES
      </motion.h2>
      <motion.div
        className="event-types"
        variants={featureContainerVariants}
        initial="hidden"
        animate="visible"
        viewport={{ once: true }}
      >
        {Features.map((feature, index) => (
          <motion.div
            key={index}
            className="event-section"
            variants={featureItemVariants}
            whileHover={{ scale: 1.08 }}
            viewport={{ once: true }}
          >
            <motion.img
              src={feature.img}
              alt="img"
              className="feature-icon"
              variants={iconVariants}
              viewport={{ once: true }}
            />
            <motion.p variants={textVariants} viewport={{ once: true }}>
              {feature.title}
            </motion.p>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default EventFeatures;
